const card = {
  namespaced: true,
  state: {
    countryCode: "",
    mobileAreaCode: ""
  },
  getters: {},
  mutations: {
    setCountryCode(state, data = "") {
      state.countryCode = data;
    },
    setMobileAreaCode(state, data = "") {
      state.mobileAreaCode = data;
    }
  },
  actions: {
    async getStoreInfo({ rootState, commit }, params = {}) {
      const data = await rootState.http("store/getStoreInfo", params);
      return data;
    },
    async getStoreInfoNoParam({ rootState, commit }, params = {}) {
      const data = await rootState.http("store/getCurrentStoreInfo", params);
      return data;
    },
    // 存储门店的相关信息
    async getCurrentStoreInfo({ rootState, commit, dispatch }, params = {}) {
      const data = await rootState.http("store/getCurrentStoreInfo", params);
      commit("setCountryCode", data.data.countryCode || "");
      dispatch("setMobileCode");
    },
    // 设置区域手机code
    async setMobileCode({ rootState, commit, dispatch, state }) {
      if (!state.mobileAreaCode) {
        const { data } = await rootState.http("/basic/findCountryPhonePrefix", {});
        console.log(data, "data");
        const findInfo = data.find(o => o.countryCode === state.countryCode);
        if (findInfo && findInfo.phonePrefix) {
          commit("setMobileAreaCode", findInfo.phonePrefix.replace(/\s+/g, "") || "");
        }
      }
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/store.js